"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/LoadingPage.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_attrs1 = {
        "class": "w-100 text-center"
      },
    marko_attrs2 = {
        "class": "placeholder"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.be("div", marko_attrs2, "2", component);

  Locale_tag({
      text: "Loading ..."
    }, out, __component, "3");

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
